import { motion } from 'framer-motion';

interface WaitingProgressProps {
  submitted: number;
  total: number;
  autoSubmitTime?: number; // seconds until auto-submit
}

const tips = [
  "Lower numbers = more control, higher = more risk",
  "Try to predict what others will pick",
  "Watch for patterns in your teammates' choices",
  "Communication is key in 67 CHAOS!",
  "Picking close to (67 - total) helps!",
];

export default function WaitingProgress({ submitted, total, autoSubmitTime }: WaitingProgressProps) {
  const progress = (submitted / total) * 100;
  const randomTip = tips[Math.floor(Math.random() * tips.length)];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="glass-card rounded-xl p-4 max-w-sm mx-auto"
    >
      {/* Progress header */}
      <div className="text-center mb-3">
        <p className="text-sm text-muted-foreground">Waiting for players...</p>
        <p className="text-3xl font-black text-primary">
          {submitted}/{total}
        </p>
      </div>

      {/* Progress bar */}
      <div className="mb-3">
        <div className="bg-secondary rounded-full h-3 overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            className="bg-primary h-full rounded-full"
            transition={{ duration: 0.3, ease: 'easeOut' }}
          />
        </div>
      </div>

      {/* Auto-submit countdown */}
      {autoSubmitTime !== undefined && autoSubmitTime > 0 && (
        <div className="text-center mb-3">
          <p className={`text-sm font-bold ${autoSubmitTime <= 10 ? 'text-chaos-red animate-pulse' : 'text-muted-foreground'}`}>
            {autoSubmitTime <= 10 ? '⚠️ ' : ''}Auto-submit in {autoSubmitTime}s
          </p>
        </div>
      )}

      {/* Tip */}
      <div className="flex items-start gap-2 text-xs text-muted-foreground">
        <span className="text-base">💡</span>
        <p>{randomTip}</p>
      </div>
    </motion.div>
  );
}
